import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-4 md:right-8 z-40 w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors animate-fade-in"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}